import React from "react";
import { Switch, Route } from "react-router-dom";
// import Header from "./Header";
import routes from "../routes";
import APPbar from './header_bar';
import Footer from './footer';
import Loading from './loading';
import Thank from './thank';
import Sorry from './sorry';
import Wechat from './wechat';

class Layout extends React.Component {
    render() {
        return (
          <Switch>
            <Route path="/product/payment/wechat" component={Wechat} />
            <Route path="/loading" component={Loading} />
            <Route path="/thanks" component={Thank} />
            <Route path="/sorry" component={Sorry} />
            <Route>
              <div className="App">
                <div className="App-header"><APPbar /></div>
                <div className="container">
                  <Switch>{ routes.map( route => <Route key={ route.path } { ...route } /> ) }</Switch>
                </div>
                <div className="footer_area"><Footer /></div>
              </div>
            </Route>
          </Switch>
        );
    }
}

export default Layout;
